if (!customElements.get('collection-tabs-carousel')) {
  class CollectionTabsCarousel extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.collection-tabs-carousel-tab'));
      this.wrapper = this.querySelector('.swiper-wrapper');
      this.swiperCarousel = this.querySelector('swiper-carousel');
      this.cta = this.querySelector('.collection-tabs-carousel-cta');
      this.mobileLayout = this.dataset.mobileLayout;
      this.mobileQuery = window.matchMedia('(max-width: 749px)');

      if (!this.tabs.length || !this.wrapper) return;

      this.allSlides = Array.from(this.wrapper.children).map((slide) => slide.cloneNode(true));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab));
      });

      this.handleResize = this.debounce(() => this.render(), 150);
      window.addEventListener('resize', this.handleResize);

      const initialTab = this.tabs.find((tab) => tab.classList.contains('active')) || this.tabs[0];
      this.activate(initialTab);

      if (window.Shopify && window.Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          if (this.tabs.includes(event.target)) this.activate(event.target);
        });
      }
    }

    disconnectedCallback() {
      if (this.handleResize) window.removeEventListener('resize', this.handleResize);
    }

    debounce(fn, delay) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), delay);
      };
    }

    activate(tab) {
      if (!tab) return;

      this.tabs.forEach((t) => {
        const isActive = t === tab;
        t.classList.toggle('active', isActive);
        t.setAttribute('aria-selected', String(isActive));
      });

      this.activeCollection = tab.dataset.collection;
      this.activeMobileLimit = parseInt(tab.dataset.mobileLimit, 10);

      if (this.cta) {
        this.cta.textContent = tab.dataset.ctaLabel || 'View All';
        this.cta.href = tab.dataset.ctaUrl || '#';
      }

      this.render();
    }

    render() {
      if (!this.activeCollection) return;

      let matches = this.allSlides.filter((slide) => slide.dataset.collection === this.activeCollection);

      // The "cards to show on mobile" block setting only truncates the mobile
      // grid — carousels handle overflow via scrolling/arrows, and desktop/
      // tablet grids intentionally show the full set.
      const isMobileGrid = this.mobileLayout === 'grid' && this.mobileQuery.matches;
      if (isMobileGrid && this.activeMobileLimit) {
        matches = matches.slice(0, this.activeMobileLimit);
      }

      const clones = matches.map((slide) => slide.cloneNode(true));
      const swiper = this.swiperCarousel && this.swiperCarousel.swiper;

      if (swiper) {
        swiper.removeAllSlides();
        swiper.appendSlide(clones);
        swiper.update();
        swiper.slideTo(0, 0);
      } else {
        this.wrapper.replaceChildren(...clones);
      }
    }
  }

  customElements.define('collection-tabs-carousel', CollectionTabsCarousel);
}
